import Vue from 'vue'
import { EagleFormConfigInterface } from '@/components/form/types/form'
class formConfig {
  protected vm?: Vue
  protected formKey?: string

  _defaultData() {
    return {

    }
  }

  get(vm: Vue, formKey: string) : EagleFormConfigInterface {
    this.vm = vm
    this.formKey = formKey

    return {
      pageTitle: (formMeta: any, formData: AnyObject) => this.vm?.$t('page.app-config.linerp'),
      hasWritePermission: (hasRole) : boolean => hasRole(['ROLE_ADMIN']),
      defaultData: this._defaultData,
      blocks: [
        {
          data: {
            greeting: {
              label: '歡迎詞',
              grid: { xl: 12, lg: 12, md: 12 },
              type: 'textarea',
              hasChanged: ({originalData, data, bothEmpty}: FormDataChangeHelperInterface) => {
                if(bothEmpty(originalData, data)) return false
                return originalData != data
              },
            },
            rich_menu_unauth: {
              label: '登入前Rich Menu',
              type: 'photo',
              disabledRemove: true,
              // @ts-ignore
              onPhotoUpdate: (photo: AnyObject) => this.vm.updateLinerpDefaultRichMenu(photo),
            },
            rich_menu_auth: {
              label: '登入後Rich Menu',
              type: 'photo',
              disabledRemove: true,
              // @ts-ignore
              onPhotoUpdate: (photo: AnyObject) => this.vm.updateLinerpProviderRichMenu(photo),
            },
          },
        },
      ],
      dataAction: {
        delete: false,
      },
    }
  }
}

export default new formConfig()
